var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fedex-disclaimer grey--text text--darken-1",class:{ 'text-center': _vm.centered }},[_vm._v(" The FedEx service marks are owned by Federal Express Corporation and are used by permission. ")])}
var staticRenderFns = []

export { render, staticRenderFns }